import { NotifyHelper } from "../../../helpers/toast";
import { objFormEditorDefine } from "../../action-types/form/IFormEditorActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const formEditorActions = {
    ...generateActions(objFormEditorDefine, "FORM_EDITOR"),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_TRUONG_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_TRUONG_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_DATASOURCE_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "LOAD_DATASOURCE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objFormEditorDefine, "FORM_EDITOR",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
